import { render, staticRenderFns } from "./OrderTrackingTable.vue?vue&type=template&id=5326de8b&"
import script from "./OrderTrackingTable.vue?vue&type=script&lang=js&"
export * from "./OrderTrackingTable.vue?vue&type=script&lang=js&"
import style0 from "./OrderTrackingTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports